
// namespace the events to reduce likeliness of dispatching events for some other modules reducer
function ns(str) {
  return 'CHATTER_POSTS_' + str
}

export const SET_HEATMAP_LOADING          = ns('SET_HEATMAP_LOADING');
export const TOGGLE_HEATMAP_RECENT_POST   = ns('TOGGLE_HEATMAP_RECENT_POST');
export const SET_POST_LIST                = ns('SET_POST_LIST');
export const SET_SELECTED_POST            = ns('SET_SELECTED_POST');
export const UNINITIALIZE                 = ns('UNINITIALIZE')
export const UPDATE_POSTS                 = ns('ADD_POST');
export const ADD_REPLIES                  = ns('ADD_REPLIES');
export const SET_FILTER                   = ns('SET_FILTER');
export const TASKS_LIST_LOADED            = ns('TASKS_LIST_LOADED');
